<template>  
  <section class="featured_image_links" :class="{'featured_image_links--with-header': schema.heading || schema.description}" ref="container" :style="componentStyles">
    <header v-if="schema.heading || schema.description" class="featured_image_links__header">
      <h2 v-if="schema.heading" class="h2" :style="textStyles">{{schema.heading}}</h2>
      <p v-if="schema.description" class="body-md" :style="textStyles">{{schema.description}}</p>
    </header>
    <section class="featured_image_links__wrapper" :class="{'featured_image_links__wrapper--three': blocks.length === 3}">
      <a 
        v-for="(block, i) in blocks" 
        ref="imageLinks" 
        :href="block.url" 
        v-bind:key="block.image+i" 
        class="featured_image_links__item" 
        :class="[isInMobileMiddleView === i ? 'featured_image_links__item--mobile': '', desktopSelected === i ? 'featured_image_links__item--desktop': '']" 
        @mouseover="itemOver(i)"
      >
        <image-ratio :src="block.image" :alt="block.image_alt" ratio="3:4" />
        <span class="featured_image_links__item-title" :style="textStyles">{{block.text}}</span>
      </a>
      <span class="featured_image_links__fullbar" :style="fullBarStyles" />
      <span class="featured_image_links__bar" :style="barStyles" />
    </section>
  </section>
</template>

<script>
import ImageRatio from '@/scripts/components/basic/ImageRatio.vue';

export default {
  name: 'FeaturedImageLinks',
  props: {
    schema: Object,
    blocks: Array
  },
  components: {
    ImageRatio
  },
  mounted() {
    this.observer = new IntersectionObserver(entries => {
      const image = entries[0];
      if (image.isIntersecting) {
        this.inView = true;
      } else {
        this.isInMobileMiddleView = -1;
        this.inView = false;
        this.barLeft = 0;
        this.desktopSelected = -1;
      }
    });


    this.observer.observe(this.$refs.container);


    this.$refs.imageLinks.map((imageLink, index) => {
      let observer = new IntersectionObserver(entries => {
        const image = entries[0];
          if (image.isIntersecting) {
            this.isInMobileMiddleView = index;
          }
      }, {
        rootMargin: '-50%',
      });
      this.mobileObserver.push(observer);

      this.mobileObserver[index].observe(this.$refs.imageLinks[index]);
    });

    this.barwidth = this.$refs.imageLinks[0].offsetWidth;

    this.barResizeObserver = new ResizeObserver(entries => {
      if (this.desktopSelected > -1) {
        const theRef = this.$refs.imageLinks[this.desktopSelected];
        const left = theRef.offsetLeft;

        this.barwidth = theRef.clientWidth;
        this.barLeft = left;
      }
    });

    this.barResizeObserver.observe(this.$refs.container);
    
  },
  data () {
    return {
      barLeft: 0,
      barWidth: 0,
      barResizeObserver: null,
      inView: false,
      observer: null,
      mobileObserver: [],
      isInMobileMiddleView: -1,
      anotherInView: false,
      desktopSelected: -1,
    }
  },
  computed: {
    componentStyles() {
      let componentStyle = {
        backgroundColor: this.schema.backgroundColor,
      }

      if (this.schema.backgroundImage) {
        componentStyle.backgroundImage = this.$mq === 'mobile' ? `url(${this.schema.backgroundImageMobile})` : `url(${this.schema.backgroundImage})`;
      }
      return componentStyle;
    },
    barStyles()  {
      return {
        left: `${this.barLeft}px`,
        width: this.barLeft ? `${this.barwidth}px` : '0px',
        backgroundColor: this.schema.uiColor,
      }
    },
    textStyles() {
      return {
        color: this.schema.uiColor
      }
    },
    fullBarStyles() {
      return {
        backgroundColor: this.schema.uiColor
      }
    }
  },
  methods: {
    itemOver(index) {
      const theRef = this.$refs.imageLinks[index];
      const left = theRef.offsetLeft;

      this.barLeft = left;
      this.desktopSelected = index;
    },
  }
}
</script>

<style scoped lang="scss">
.featured_image_links {
  padding: 80px 28px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-size: 350px 350px;
  background-repeat: repeat;
  background-position: center center;

  @include tablet-up {
    padding-top: 104px;
    padding-bottom: 132px;
    min-height: 650px;
  }

  &--with-header {
    @include tablet-up {
      min-height: 714px;
    }
  }
}

.featured_image_links__header {
  max-width: 500px;
  padding: 0 0 30px;
  text-align: center;

  .h2 {
    line-height: rem(35);
    @include tablet-up {
      line-height: rem(48);
    }
  }
  .body-md {
    line-height: rem(23);
  }
}

.featured_image_links__wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;

  @include tablet-up {
    max-width: 968px;
    flex-direction: row;
    width: 100%;
    position: relative;
    justify-content: center;
  }
}
.featured_image_links__wrapper--three {
  @include tablet-up {
    justify-content: space-between;
  }
}

.featured_image_links__fullbar {
  @include tablet-up {
    width: 100%;
    left: 0;
    height: 1px;
    top: 50%;
    transform: translateY(-50%);
    display: block;
    position: absolute;
    opacity: .35;
  }
}

.featured_image_links__bar {
  display: none;
  @include tablet-up {
    position: absolute;
    top: 50%;
    left: 37px;
    height: 3px;
    width: 0;
    transform: translateY(-50%);
    display: block;
    transition: all .75s $default-animation-timing;
  }
}

.featured_image_links__item {
  margin: 0 auto 48px;
  color: $color-white;
  display: block;
  font-family: $font-family-primary;
  max-width: 233px;
  width: 100%;
  text-decoration: none;
  position: relative;
  padding-top: 23px;

  @include tablet-up {
    padding-top: 0;
    margin: 0 37px;
  }
  .ratio-image {
    /* transition-property: all;
      transition-duration: .2s; */
  }

  &:not(.featured_image_links__item--mobile) {
    .ratio-image {
      opacity: .15;
    }
  }

  
  @include tablet-up {
    .ratio-image {
      opacity: .15;
    }
    &.featured_image_links__item--desktop,
    &:hover {
      .ratio-image {
        opacity: 1;
      }
    }
  }
}

.featured_image_links__item-title {
  top: 3px;
  font-size: rem(28);
  line-height: rem(34);
  position: absolute;
  width: 100%;
  text-align: center;
  left: 0;

  @include tablet-up {
    top: 50%;
    padding: 26px 10px 0;
    font-size: rem(32);
    line-height: rem(42);
  }
}
</style>
